'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const buttonGroup_types = require('./buttonGroup.types.js');

var ButtonGroupWrapper = styled__default.div.withConfig({
  displayName: "buttonGroupstyle__ButtonGroupWrapper",
  componentId: "sc-1ltzngf-0"
})(["display:flex;flex-direction:", ";overflow:", ";overflow-x:", ";overflow-y:", ";-webkit-overflow-scrolling:touch;"], function (_ref) {
  var inline = _ref.inline;
  return inline ? 'row' : 'column';
}, function (_ref2) {
  var overflow = _ref2.overflow;
  return overflow ? overflow : buttonGroup_types.OverflowTypes.VISIBLE;
}, function (_ref3) {
  var overflow = _ref3.overflow,
    inline = _ref3.inline;
  return overflow && inline ? overflow : buttonGroup_types.OverflowTypes.VISIBLE;
}, function (_ref4) {
  var overflow = _ref4.overflow,
    inline = _ref4.inline;
  return overflow && !inline ? overflow : buttonGroup_types.OverflowTypes.VISIBLE;
});

exports.ButtonGroupWrapper = ButtonGroupWrapper;
